var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChaijs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A1070C;}\n\t.st1{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,46.6L32,61.2l25.3-14.6V17.4L32,2.8L6.7,17.4V46.6L6.7,46.6z M32,64L4.3,48V16L32,0l27.7,16v32L32,64 L32,64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -527.6675,
    y1: 1029.4197,
    x2: -527.6675,
    y2: 1029.3011,
    gradientTransform: "matrix(236.842 0 0 -273.481 125005.8438 281555.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7F6F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEF6D5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.4,17.2L32,2.4l25.6,14.8v29.6L32,61.6L6.4,46.8V17.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,21.2c0,1.2-0.2,2.3-0.7,3.5c-0.5,1.1-1.1,2.2-1.8,3.2c-0.8,1-1.7,1.8-2.7,2.6c-1,0.7-2.1,1.3-3.1,1.6 l-0.5-0.8c0.6-0.3,1.2-0.7,1.8-1.2c0.5-0.5,1-1.1,1.4-1.7c0.4-0.6,0.7-1.3,0.9-2c0.2-0.7,0.3-1.4,0.3-2.2c0-0.8-0.1-1.6-0.4-2.4 c-0.2-0.7-0.6-1.4-1.1-2c-0.5-0.6-1.1-1-1.8-1.3c-0.7-0.3-1.5-0.5-2.4-0.5c-1.1,0-2.1,0.2-3,0.6c-0.9,0.4-1.7,1-2.5,1.7 s-1.4,1.6-1.9,2.5c-0.5,0.9-1,1.9-1.4,3c-0.4,1-0.6,2.1-0.8,3.1c-0.2,1.1-0.3,2.1-0.3,3c0,0.9,0.1,1.9,0.3,2.9c0.2,1,0.5,2,0.9,3 c0.4,1,0.9,1.9,1.4,2.8c0.6,0.9,1.2,1.6,2,2.3c0.7,0.7,1.6,1.2,2.5,1.6c0.9,0.4,1.9,0.6,3,0.6c0.7,0,1.4-0.1,2.1-0.3 c0.7-0.2,1.4-0.5,2-0.8c0.6-0.3,1.3-0.7,1.8-1.2c0.6-0.5,1.1-1,1.6-1.5l0.8,0.7c-0.7,0.9-1.5,1.7-2.4,2.6c-0.9,0.8-1.9,1.5-3,2.2 c-1.1,0.6-2.2,1.1-3.4,1.5c-1.2,0.4-2.3,0.6-3.5,0.6c-1.1,0-2.2-0.2-3.2-0.6c-1-0.4-1.9-0.9-2.7-1.6s-1.6-1.4-2.2-2.3 c-0.7-0.9-1.2-1.8-1.7-2.9c-0.5-1-0.8-2.1-1-3.1c-0.2-1.1-0.4-2.1-0.4-3.1c0-1.5,0.2-3,0.7-4.6c0.5-1.6,1.2-3.1,2.1-4.6 c0.9-1.5,1.9-2.9,3.1-4.2c1.2-1.3,2.5-2.5,3.8-3.4c1.4-1,2.8-1.8,4.3-2.3c1.5-0.6,3-0.9,4.5-0.9c0.9,0,1.8,0.1,2.6,0.4 c0.8,0.3,1.5,0.7,2.1,1.2c0.6,0.5,1,1.1,1.4,1.9C43.6,19.3,43.8,20.2,43.8,21.2L43.8,21.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaijs);
export default __webpack_public_path__ + "static/media/chaijs.b9d15b7fb3154037d10ba5fc649d77f3.svg";
export { ForwardRef as ReactComponent };